<template>
  <div>
    <v-layout style="background-color:#F3F3F3" wrap justify-center py-4 px-2>
      <v-flex xs12 lg10 xl10>
        <v-layout>
          <v-flex style="text-align:left;">
            <span style="text-align:left;font-family:opensansextrabold;font-size:18px;">
              <!-- <v-icon style="color:black;font-size:14px;">mdi-circle-outline</v-icon>Your Products -->
            </span>
          </v-flex>
          <v-flex xs12 md3 lg>
            <v-layout>
              <v-flex md3 lg3>
                <v-img
                  src="./../../../assets/images/dummy.jpg"
                  aspect-ratio="1"
                  contain
                  height="57px"
                ></v-img>
              </v-flex>
              <v-flex md8 lg8 style="text-align:left">
                <span
                  style="font-family:opensansbold;font-size:14px;color:#000000"
                >{{user.fullname}}</span>
                <br />
                <span
                  @click="appLogout"
                  style="font-family:opensanssemibold;font-size:14px;cursor:pointer;color:#979696"
                >Logout</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout style="background-color:#F3F3F3" wrap justify-left>
      <v-flex pt-3 xs12 sm10 md10 lg10 offset-md1>
        <AddProduct v-if="addProduct" @stepper="winStepper" />
        <EditProduct
          v-if="editProduct"
          v-bind:product="productData"
          :key="editProduct"
          @stepper="winStepper"
        />
      </v-flex>
    </v-layout>

    <v-layout v-if="!editProduct" style="background-color:#F3F3F3" py-3 wrap justify-center>
      <v-flex text-center xs12 md6 lg4 xl3>
        <v-btn
          small
          color="#F9F9F9"
          style="font-family:opensansextrabold;border: 0.5px solid #B1B1B1;text-transform:none"
          width="80%"
          depressed
          :ripple="false"
          @click="addProduct=!addProduct"
        >
          <span v-if="!addProduct">
            <v-icon>mdi-plus</v-icon>&nbsp;Add New Product
          </span>
          <span v-else class="align-self-center">
            <v-icon size="16">mdi-close</v-icon>&nbsp;Cancel
          </span>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout v-if="editProduct" style="background-color:#F3F3F3" py-3 wrap justify-center>
      <v-flex text-center xs12 md6 lg4 xl3>
        <v-btn
          small
          color="#F9F9F9"
          style="font-family:opensansextrabold;border: 0.5px solid #B1B1B1;text-transform:none"
          width="80%"
          depressed
          :ripple="false"
          @click="editProduct=!editProduct"
        >
          <span class="align-self-center">
            <v-icon size="16">mdi-close</v-icon>&nbsp;Cancel
          </span>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout pt-4 wrap justify-left>
      <v-flex xs12 sm10 md10 lg10 offset-md1>
        <Inventory v-bind:myProducts="myProducts" @stepper="winStepper" />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import store from "./../../../store";
import AddProduct from "./addProduct";
import EditProduct from "./editProduct";
import Inventory from "./inventory";
export default {
  components: {
    AddProduct,
    EditProduct,
    Inventory,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      myProducts: [],
      addProduct: false,
      editProduct: false,
      productData: {},
      user: {},
      listStatus: "active",
    };
  },
  watch: {
    editProduct() {
      if (!this.editProduct) this.getProducts();
    },
  },
  beforeMount() {
    this.getProfile();
    this.getProducts();
  },
  methods: {
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.user = response.data.data;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    appLogout() {
      store.commit("logoutUser", true);
    },
    winStepper(window_data) {
      if (window_data.getList) {
        this.addProduct = false;
        this.editProduct = false;
        this.productData = {};
        if (window_data.listStatus) {
          this.listStatus = window_data.listStatus;
        }
        this.getProducts();
      }
      if (window_data.editProduct) {
        this.productData = window_data.product;
        this.editProduct = true;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    },
    getProducts() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/product/myproducts",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.myProducts = response.data.data;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>